import { NavLink } from "react-router-dom";
import { Search, Gauge, Table2, BookOpen, Menu } from "lucide-react";
import { useT } from "@/lib/i18n";
import { useSimple } from "@/lib/simple";

const FULL = [
  { to: "/", label: "Find", Icon: Search, id: "index" },
  { to: "/drop", label: "Drop", Icon: Gauge, id: "drop" },
  { to: "/chart", label: "Chart", Icon: Table2, id: "chart" },
  { to: "/tanks", label: "Tanks", Icon: BookOpen, id: "tanks" },
  { to: "/more", label: "More", Icon: Menu, id: "more" },
];

const SIMPLE = [
  { to: "/", label: "Check a tank", Icon: Search, id: "index" },
  { to: "/drop", label: "Plan a drop", Icon: Gauge, id: "drop" },
  { to: "/more", label: "More", Icon: Menu, id: "more" },
];

export function BottomTabs() {
  const t = useT();
  const simple = useSimple();
  return (
    <nav className={`tabbar ${simple ? "tabbar-simple" : ""}`} data-testid="bottom-tabs">
      {(simple ? SIMPLE : FULL).map(({ to, label, Icon, id }) => (
        <NavLink key={id} to={to} end className={({ isActive }) => `tab ${isActive ? "tab-active" : ""}`} data-testid={`tab-${id}`}>
          <Icon size={simple ? 26 : 22} />
          <span>{t(label)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
